import { Flex, Heading, Text } from "@chakra-ui/react";
import React from "react";

const HeaderClient = ({ clientData }) => {
  return (
    <>
      <Flex style={{ padding: "5px 10px" }}>
        <Heading
          fontSize="var(--sylvr-h3-fs)"
          fontWeight="var(--sylvr-h3-fw)"
          color="var(--sylvr-text-color)"
          pr={3}
        >
          {clientData?.companyName}
        </Heading>
        <Text
          fontStyle="italic"
          borderLeft="3px solid #E6E6E6"
          px={2}
          fontSize="var(--sylvr-h4-fs)"
          fontWeight="var(--sylvr-h5-fw)"
          color="var(--sylvr-text-color)"
        >
          {clientData?.sector?.sectorName}
        </Text>
      </Flex>
    </>
  );
};

export default HeaderClient;
